var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"added-docs",attrs:{"data-testid":"added-docs"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }